import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { PublicProfileData } from '@/types/dashboard';

// Lets the home/* profile sections read the public profile without each one
// re-fetching or knowing the handle — CreatorPage fetches once and provides it.
const PublicProfileContext = createContext<PublicProfileData | null>(null);

const TrackingContext = createContext<boolean>(false);

export function PublicProfileProvider({
  value,
  tracking = false,
  children,
}: {
  value: PublicProfileData;
  tracking?: boolean;
  children: ReactNode;
}) {
  return (
    <PublicProfileContext.Provider value={value}>
      <TrackingContext.Provider value={tracking}>
        {children}
      </TrackingContext.Provider>
    </PublicProfileContext.Provider>
  );
}

export function usePublicProfileData(): PublicProfileData {
  const ctx = useContext(PublicProfileContext);
  if (!ctx) {
    throw new Error(
      'usePublicProfileData must be used within a PublicProfileProvider',
    );
  }
  return ctx;
}

export function useProfileTracking(): boolean {
  return useContext(TrackingContext);
}
